
import { defineComponent } from "vue";
import { IFiscalPeriodsModel, IAcademicYearModel } from "@/interfaces/modules";
import FiscalPeriodsService from "@/api/Collection/FiscalPeriodsService";
import AcademicYearsService from "@/api/Configuration/AcademicYearService";
import store from "@/store";

export default defineComponent({
  name: "FiscalPeriodsContent",
  data() {
    return {
      fiscalYears: [] as IAcademicYearModel[],
      form: {
        dialog: false,
        record: {} as IFiscalPeriodsModel,
      },
      table: {
        filters: { search: "" },
        currentPage: 1,
        loading: false,
        headers: [
          { key: "FiscalYearId", label: "Año fiscal", sortable: true },
          { key: "PeriodNumber", label: "Número", sortable: true },
          { key: "PeriodStart", label: "Inicio", sortable: true },
          { key: "PeriodEnd", label: "Fin", sortable: true },
          { key: "GracePeriod", label: "Gracia (días)", sortable: true },
          { key: "Enable", label: "Activo", sortable: true },
          { key: "AllowCollections", label: "Permite recaudos", sortable: true },
          { key: "Observations", label: "Observaciones", sortable: true },
          { key: "CreatedByFormat", label: "Creación", sortable: true },
          { key: "ModifiedByFormat", label: "Última modificación", sortable: true },
          { key: "action", label: "Acciones", sortable: false },
        ],
        records: [] as IFiscalPeriodsModel[],
        rowsPerPage: 10,
      } as any,
    };
  },
  async mounted() {
    await this.load();
  },
  computed: {
    filteredItems(): any {
      const q = this.table.filters.search?.toLowerCase() || "";
      return q
        ? this.table.records.filter((item: IFiscalPeriodsModel) =>
          [item.Observations, item.GracePeriod, item.PeriodNumber]
            .filter(Boolean)
            .some(v => String(v).toLowerCase().includes(q))
        )
        : this.table.records;
    },
    rows(): number {
      return this.table.records?.length || 0;
    },
  },
  methods: {
    async load() {
      this.table.loading = true;
      this.table.records = await FiscalPeriodsService.GetFiscalPeriods();
      this.fiscalYears = await AcademicYearsService.GetAcademicYears();
      this.table.loading = false;
    },
    async edit(data: IFiscalPeriodsModel) {
      this.form.record = await FiscalPeriodsService.GetFiscalPeriodById({ Id: data.Id } as any);
      this.form.record.PeriodStart = this.form.record.PeriodStart.substring(0, 10);
      this.form.record.PeriodEnd = this.form.record.PeriodEnd.substring(0, 10);
      this.form.dialog = true;
    },
    openModal() {
      this.form.record = {
        Id: 0,
        FiscalYearId: 0,
        PeriodNumber: 0,
        PeriodStart: "",
        PeriodEnd: "",
        GracePeriod: 0,
        Observations: "",
        Enable: true,
        AllowCollections: false,
        CreatedBy: 0,
        CreatedDate: "",
      } as IFiscalPeriodsModel;
      this.form.dialog = true;
    },
    async handleSubmit() {
      this.form.dialog = false;
      await FiscalPeriodsService.PostFiscalPeriod(this.form.record);
      store.dispatch("core/popupDialog", {
        text: "Registro guardado con éxito.",
        type: "success",
        showCancelButton: false,
      });
      this.load();
    },
  },
});
